import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface ItemCardStockProps {
  remain_stock: number;
}
export const ItemCardStock = ({ remain_stock }: ItemCardStockProps) => {
  return <StockText>{remain_stock}개 남음</StockText>;
};

const StockText = styled.span`
  height: 14px;
  font-size: 12px;
  font-weight: 400;
  color: ${vars.v3Color.red200};
`;
